module.exports = __webpack_public_path__ + "img/whatIsUrbanMining@2x.9e3552b.webp";